// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
.AuthorCommonPage_pageWrapper__rfwCx {
  background-color: #000;
  min-height: 100vh;
  padding: 80px 20px 0;
  display: flex;
  justify-content: center;
}

.AuthorCommonPage_detailContainer__DVyvr {
  width: 100%;
  max-width: 1000px;
  background-color: #111;
  color: white;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
}

/* Cover Image */
.AuthorCommonPage_coverImageContainer__kSz0y {
  width: 100%;
  height: 300px;
  position: relative;
  overflow: hidden;
}

.AuthorCommonPage_coverImage__AOUSx {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: brightness(0.7);
}

/* Profile Section */
.AuthorCommonPage_profileSection__H4TrL {
  padding: 0 40px;
  display: flex;
  gap: 40px;
  align-items: center;
}

/* Left Side (Profile Image) */
.AuthorCommonPage_profileLeft__KoLZM {
  flex-shrink: 0;
  width: 120px;
  display: flex;
  justify-content: center;
}

.AuthorCommonPage_profileImageWrapper__zJ\\+Ip {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #111;
  margin-top: -150px;
  position: relative;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.AuthorCommonPage_profileImageWrapper__zJ\\+Ip:hover {
  opacity: 0.8;
}

.AuthorCommonPage_profileImage__VT710 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Right Side (Profile Content) */
.AuthorCommonPage_profileRight__dSCql {
  flex-grow: 1;
  padding-top: 20px;
}

.AuthorCommonPage_nameSection__1P5It {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.AuthorCommonPage_authorName__EFgCq {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  color: #fff;
}

/* Follow/Following Button Styles */
/* NOT following state – "Follow" button: Red background with white text */
.AuthorCommonPage_followButton__DZAAs {
  padding: 8px 24px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.AuthorCommonPage_notFollowing__Ofk2O {
  background-color: #ff0000;
  color: white;
  border: none;
}

.AuthorCommonPage_notFollowing__Ofk2O:hover {
  background-color: #cc0000;
}

/* Following state – "Following" button: Black background with red border and white text */
.AuthorCommonPage_following__caSc1 {
  background-color: #000;
  color: white;
  border: 2px solid #ff0000;
}

.AuthorCommonPage_following__caSc1:hover {
  background-color: #222;
}

.AuthorCommonPage_authorBio__lQLKa {
  color: #888;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

/* Modal Styles */
.AuthorCommonPage_modalOverlay__SSy33 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.AuthorCommonPage_modalContent__uIXkV {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
  overflow: hidden;
}

.AuthorCommonPage_previewImage__1Uvvk {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.AuthorCommonPage_closeButton__UMdmk {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: background-color 0.3s ease;
}

.AuthorCommonPage_closeButton__UMdmk:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .AuthorCommonPage_pageWrapper__rfwCx {
    padding: 60px 15px 0;
  }
  .AuthorCommonPage_profileSection__H4TrL {
    flex-direction: column;
    text-align: center;
    padding: 0 20px;
  }
  .AuthorCommonPage_profileLeft__KoLZM {
    width: 100%;
  }
  .AuthorCommonPage_nameSection__1P5It {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
  }
  .AuthorCommonPage_authorBio__lQLKa {
    text-align: center;
  }
}

@media (max-width: 768px) {
  .AuthorCommonPage_pageWrapper__rfwCx {
    padding: 40px 10px 0;
  }
  .AuthorCommonPage_coverImageContainer__kSz0y {
    height: 200px;
  }
  .AuthorCommonPage_profileImageWrapper__zJ\\+Ip {
    width: 100px;
    height: 100px;
    margin-top: -50px;
  }
  .AuthorCommonPage_authorName__EFgCq {
    font-size: 1.3rem;
  }
  .AuthorCommonPage_followButton__DZAAs {
    padding: 6px 18px;
    font-size: 0.9rem;
  }
  .AuthorCommonPage_modalContent__uIXkV {
    width: 95vw;
  }
}

@media (max-width: 480px) {
  .AuthorCommonPage_profileSection__H4TrL {
    gap: 10px;
    padding: 0 15px;
  }
  .AuthorCommonPage_coverImageContainer__kSz0y {
    height: 180px;
  }
  .AuthorCommonPage_profileImageWrapper__zJ\\+Ip {
    width: 80px;
    height: 80px;
    margin-top: -40px;
  }
  .AuthorCommonPage_authorName__EFgCq {
    font-size: 1.2rem;
  }
  .AuthorCommonPage_authorBio__lQLKa {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/components/Css/AuthorCommonPage.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA,mCAAmC;AACnC,0EAA0E;AAC1E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0FAA0F;AAC1F;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* General Styles */\n.pageWrapper {\n  background-color: #000;\n  min-height: 100vh;\n  padding: 80px 20px 0;\n  display: flex;\n  justify-content: center;\n}\n\n.detailContainer {\n  width: 100%;\n  max-width: 1000px;\n  background-color: #111;\n  color: white;\n  margin-top: 20px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* Cover Image */\n.coverImageContainer {\n  width: 100%;\n  height: 300px;\n  position: relative;\n  overflow: hidden;\n}\n\n.coverImage {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  filter: brightness(0.7);\n}\n\n/* Profile Section */\n.profileSection {\n  padding: 0 40px;\n  display: flex;\n  gap: 40px;\n  align-items: center;\n}\n\n/* Left Side (Profile Image) */\n.profileLeft {\n  flex-shrink: 0;\n  width: 120px;\n  display: flex;\n  justify-content: center;\n}\n\n.profileImageWrapper {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 4px solid #111;\n  margin-top: -150px;\n  position: relative;\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n}\n\n.profileImageWrapper:hover {\n  opacity: 0.8;\n}\n\n.profileImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Right Side (Profile Content) */\n.profileRight {\n  flex-grow: 1;\n  padding-top: 20px;\n}\n\n.nameSection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.authorName {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0;\n  color: #fff;\n}\n\n/* Follow/Following Button Styles */\n/* NOT following state – \"Follow\" button: Red background with white text */\n.followButton {\n  padding: 8px 24px;\n  border-radius: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.notFollowing {\n  background-color: #ff0000;\n  color: white;\n  border: none;\n}\n\n.notFollowing:hover {\n  background-color: #cc0000;\n}\n\n/* Following state – \"Following\" button: Black background with red border and white text */\n.following {\n  background-color: #000;\n  color: white;\n  border: 2px solid #ff0000;\n}\n\n.following:hover {\n  background-color: #222;\n}\n\n.authorBio {\n  color: #888;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.previewImage {\n  max-width: 100%;\n  max-height: 90vh;\n  object-fit: contain;\n}\n\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.closeButton:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .pageWrapper {\n    padding: 60px 15px 0;\n  }\n  .profileSection {\n    flex-direction: column;\n    text-align: center;\n    padding: 0 20px;\n  }\n  .profileLeft {\n    width: 100%;\n  }\n  .nameSection {\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    text-align: center;\n  }\n  .authorBio {\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .pageWrapper {\n    padding: 40px 10px 0;\n  }\n  .coverImageContainer {\n    height: 200px;\n  }\n  .profileImageWrapper {\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n  }\n  .authorName {\n    font-size: 1.3rem;\n  }\n  .followButton {\n    padding: 6px 18px;\n    font-size: 0.9rem;\n  }\n  .modalContent {\n    width: 95vw;\n  }\n}\n\n@media (max-width: 480px) {\n  .profileSection {\n    gap: 10px;\n    padding: 0 15px;\n  }\n  .coverImageContainer {\n    height: 180px;\n  }\n  .profileImageWrapper {\n    width: 80px;\n    height: 80px;\n    margin-top: -40px;\n  }\n  .authorName {\n    font-size: 1.2rem;\n  }\n  .authorBio {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `AuthorCommonPage_pageWrapper__rfwCx`,
	"detailContainer": `AuthorCommonPage_detailContainer__DVyvr`,
	"coverImageContainer": `AuthorCommonPage_coverImageContainer__kSz0y`,
	"coverImage": `AuthorCommonPage_coverImage__AOUSx`,
	"profileSection": `AuthorCommonPage_profileSection__H4TrL`,
	"profileLeft": `AuthorCommonPage_profileLeft__KoLZM`,
	"profileImageWrapper": `AuthorCommonPage_profileImageWrapper__zJ+Ip`,
	"profileImage": `AuthorCommonPage_profileImage__VT710`,
	"profileRight": `AuthorCommonPage_profileRight__dSCql`,
	"nameSection": `AuthorCommonPage_nameSection__1P5It`,
	"authorName": `AuthorCommonPage_authorName__EFgCq`,
	"followButton": `AuthorCommonPage_followButton__DZAAs`,
	"notFollowing": `AuthorCommonPage_notFollowing__Ofk2O`,
	"following": `AuthorCommonPage_following__caSc1`,
	"authorBio": `AuthorCommonPage_authorBio__lQLKa`,
	"modalOverlay": `AuthorCommonPage_modalOverlay__SSy33`,
	"modalContent": `AuthorCommonPage_modalContent__uIXkV`,
	"previewImage": `AuthorCommonPage_previewImage__1Uvvk`,
	"closeButton": `AuthorCommonPage_closeButton__UMdmk`
};
export default ___CSS_LOADER_EXPORT___;
